import { css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { OmegaComponent } from "@omegagrid/core";
import { msg } from "@omegagrid/localize";
import { CellModel } from "@omegagrid/grid";
import { formatSeconds } from "@reporting/rp-app-host";
import { JobSchedule } from "@reporting/rp-types/server";

@customElement('rp-super-job-detail')
export class JobScheduleDetail extends OmegaComponent {

	static styles = [OmegaComponent.styles, css`
		table {
			border-collapse: collapse;
			width: 100%;
			font-size: 10px;
		}
		th, td {
			border: 1px solid var(--og-colortype-yellow-border-color);
			padding: 2px;
		}
		th {
			text-align: left;
			width: 100px;
		}
		a { color: red !important; }
		a:hover { text-decoration: underline; cursor: pointer; }
	`];

	@property({type: Object})
	cell: CellModel;

	render = () => {
		const props = this.cell?.properties as JobSchedule;
		return props ? html`
			<table>
				<tr>
					<th colspan="2">${props.schedule_name || '-'}</th>
				</tr>
				<tr>
					<th>${msg('Start')}:</th>
					<td>
						${props.time.split('.')[0] || '-'}
					</td>
				</tr>
				<tr>
					<th>${msg('Duration')}:</th>
					<td>
						${formatSeconds(props.run_duration)}
					</td>
				</tr>
			</table>
		` : '';
	}

}
